module.exports = __webpack_public_path__ + "static/img/12.454e341.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/12.png
// module id = o/DL
// module chunks = 0